module.exports = __webpack_public_path__ + "static/img/son6_active.b65d58f2.png";